// @flow
import * as React from 'react';
import { Stream, StreamContext, CTX_ANNOUNCEMENT_STREAM } from 'chat/components/Stream';
import AnnouncementStreamContainer from './AnnouncementStreamContainer.jsx';

type Props = {
  uuid: string,
  onScrollToBottom?: Function,
};

class AnnouncementStream extends React.Component<Props, *> {
  stream: Stream;

  handleNewBottomItem = () => {
    if (this.stream) {
      this.stream.scrollToBottom();
    }
  };

  render() {
    return (
      <StreamContext.Provider value={CTX_ANNOUNCEMENT_STREAM}>
        <AnnouncementStreamContainer
          uuid={this.props.uuid}
          onNewBottomItem={this.handleNewBottomItem}>
          {props => (
            <Stream
              {...props}
              uuid={this.props.uuid}
              ref={(e: any) => (this.stream = e)}
              onScrollToBottom={this.props.onScrollToBottom}
            />
          )}
        </AnnouncementStreamContainer>
      </StreamContext.Provider>
    );
  }
}

export default AnnouncementStream;
